import { render, staticRenderFns } from "./DragAndDropComponent.vue?vue&type=template&id=34b8fc82"
import script from "./DragAndDropComponent.vue?vue&type=script&lang=js"
export * from "./DragAndDropComponent.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropComponent.vue?vue&type=style&index=0&id=34b8fc82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VFileInput,VIcon,VRow})
